module.exports = __webpack_public_path__ + "static/media/micr.f86428a1.jpg";